export default __webpack_public_path__ + "static/media/mailIcon.c550bdc5.svg";